.eds-menu {
  background-color: var(--eds--color--bg-base);
  border: 1px solid var(--eds--color--border-default);
  border-radius: var(--eds--radii-8);
  box-shadow: var(--eds--elevation-floating);
  max-height: var(--_available-height, none);
  overflow-y: auto;
  padding: var(--eds--padding-8);
  z-index: var(--eds--z-index-floating);
}

.eds-menu--header {
  padding: var(--eds--padding-8);
}

.eds-menu--group-divider {
  height: 1px;
  background-color: var(--eds--color--bg-muted-default);
  margin: var(--eds--spacing-8) var(--eds--spacing-none);
}

.eds-menu--group-header {
  padding: var(--eds--padding-4) var(--eds--padding-8);
  text-transform: uppercase;
}

.eds-menu--items {
  /* An item with a tooltip renders a Tooltip trigger around its button, and
     that trigger is `width: fit-content` by default — stretch it through its
     own `--_width` hook so tooltipped and plain items share one width. */
  --_width: 100%;
}

/* The menu is a focus host (`tabIndex={-1}`), not a control: floating-ui parks
   focus here whenever no item is active, so the user-agent ring would flash on
   and off the surface while the pointer moves between items. The active item
   owns the visible focus indicator. */
.eds-menu:focus-visible {
  outline: none;
}
